import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from 'shared/errors';
import {
  IGetUserDataByRequestRequest,
  TGetUserDataByRequestResponse,
  fetchGetUserDataByRequest,
} from 'shared/repositories/monolith-python/v1/get-user-data-by-request';

export const fetchUser = async ({ httpApi, logger }: IApplicationContext, parameters: IGetUserDataByRequestRequest) => {
  try {
    const { response, statusCode }: TGetUserDataByRequestResponse = await fetchGetUserDataByRequest({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchUser',
        message: response.message || '',
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    return response;
  } catch (e) {
    logger.error(e, {
      domain: 'fetchUser',
      parameters: JSON.stringify(parameters),
    });

    return { isAuthenticated: false };
  }
};
